module.exports = __webpack_public_path__ + "static/media/11.7318c6e3.jpg";